module.exports = __webpack_public_path__ + "static/media/planet.259611b7.svg";